import { useEffect, useState } from 'react';
import { verifyReferralCodeApi } from '../services/referralCodeApi/referralCodeApi';
import { toastNotify } from '../utils/toastNotify';

/**
 * Referral-code prefill + "preview order" bonus-share check shared by the
 * initial-offering quick-buy Modal and Drawer variants.
 */
export const useReferralBonusPreview = (userProfileData, onPreviewComplete) => {
  const [pinSuccessReferralcode, setPinSuccessReferralCode] = useState();
  const [bonusSharesAwarded, setBonusSharesAwarded] = useState(false);
  const [previewOrderLoader, setPreviewOrderLoader] = useState(false);
  const [disableReferralInputField, setDisableReferralInputField] = useState(false);

  useEffect(() => {
    if (userProfileData?.referralCode) {
      const setReferralcode = userProfileData?.referralCode;
      setPinSuccessReferralCode(setReferralcode);
    }
  }, [userProfileData]);

  const handlePreviewOrder = async () => {
    if (pinSuccessReferralcode) {
      const reqBody = {
        referralCode: pinSuccessReferralcode,
      };
      setPreviewOrderLoader(true);
      try {
        const response = await verifyReferralCodeApi(reqBody);
        if (response?.data?.isReferralValid && response?.data?.isFirstOrder) {
          setBonusSharesAwarded(true);
          setDisableReferralInputField(true);
        } else {
          setBonusSharesAwarded(false);
          setDisableReferralInputField(false);
        }
      } catch (error) {
        toastNotify('error', 'Error verifying referral code:');
      } finally {
        setPreviewOrderLoader(false);
      }
    }
    onPreviewComplete();
  };

  return {
    pinSuccessReferralcode,
    setPinSuccessReferralCode,
    bonusSharesAwarded,
    setBonusSharesAwarded,
    previewOrderLoader,
    disableReferralInputField,
    setDisableReferralInputField,
    handlePreviewOrder,
  };
};
